export enum JobPhaseReadinessEnum {
  ReadyNow = 'ReadyNow',
  ReadyLater = 'ReadyLater',
  Done = 'Done',
}
